import { SearchSuggestResponseSchema, type SearchSuggestion } from "@kraahl/contract";

/**
 * Autocomplete adapter — the single `/api/search/suggest` caller. Keeps
 * `fetch('/api/...')` out of components/hooks (HARD GATE — CLAUDE.md); parses
 * the response on the boundary, with raw passthrough on drift.
 */
export async function fetchSearchSuggestions(
  q: string,
  opts?: { signal?: AbortSignal },
): Promise<SearchSuggestion[]> {
  const response = await fetch(`/api/search/suggest?q=${encodeURIComponent(q)}`, {
    signal: opts?.signal,
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch: ${response.status}`);
  }

  const json = await response.json();
  const parsed = SearchSuggestResponseSchema.safeParse(json);
  if (!parsed.success) {
    console.warn("[search] suggest response failed contract parse", parsed.error.issues);
    return (json?.suggestions ?? []) as SearchSuggestion[];
  }
  return parsed.data.suggestions;
}
